import { render, staticRenderFns } from "./PurchaseRequests.vue?vue&type=template&id=702525fe&scoped=true"
import script from "./PurchaseRequests.vue?vue&type=script&lang=js"
export * from "./PurchaseRequests.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequests.vue?vue&type=style&index=0&id=702525fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702525fe",
  null
  
)

export default component.exports